import React from 'react'

const HamburgerIcon = (
  <>
    <path
      d="M17 1.26123L1 17.2612"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 17.2612L1 1.26123"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>
)

export default HamburgerIcon
